import { createSlice, createAction, PayloadAction } from '@reduxjs/toolkit';

import { IMyProfileForm, IProfileSettings, IUserPreferences } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: IProfileSettings = {
  profileForm: {},
  notificationSettings: {
    promotionalEmails: false,
    notificationsForMeal: false,
  },
  userPreferences: {
    data: {
      favoriteCuisines: [],
      dietaryRestrictions: [],
      allergies: [],
      spiceLevel: '',
      mealPrepTime: '',
      comfortLevel: '',
    },
  },
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateProfileForm(state, action: PayloadAction<IMyProfileForm>) {
      state.profileForm.status = RequestStatus.RUNNING;
    },
    updateProfileFormSuccess(state) {
      state.profileForm.status = RequestStatus.SUCCESS;
    },
    updateProfileFormFailed(state, action: PayloadAction<IRequestFailed>) {
      state.profileForm.status = RequestStatus.ERROR;
    },

    setProfileForm: (state, action) => {
      state.profileForm = action.payload;
    },
    setNotificationSettings: (state, action) => {
      state.notificationSettings = action.payload;
    },
    updateUserPreferences: (state, action: PayloadAction<IUserPreferences>) => {
      state.userPreferences.status = RequestStatus.RUNNING;
    },
    updateUserPreferencesSuccess: (state, action) => {
      state.userPreferences.status = RequestStatus.SUCCESS;
      state.userPreferences.data = action.payload;
    },
    updateUserPreferencesFailed: (state, action: PayloadAction<IRequestFailed>) => {
      state.userPreferences.status = RequestStatus.ERROR;
      state.userPreferences.error = action.payload;
    },
    setMyProfile: (state, action) => {
      state.myProfile = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  updateProfileForm,
  updateProfileFormSuccess,
  updateProfileFormFailed,
  setProfileForm,
  setNotificationSettings,
  updateUserPreferences,
  updateUserPreferencesSuccess,
  updateUserPreferencesFailed,
  setMyProfile,
} = slice.actions;

export const updateNotificationSettings = createAction<{
  promotionalEmails: Boolean;
  notificationsForMeal: Boolean;
  userId: number;
}>('Manage_PROFILE/UPDATE_NOTIFICATION_SETTINGS');

export const getUserNotificationSettings = createAction<{
  userId: number;
}>('Manage_PROFILE/GET_USER_NOTIFICATION_SETTINGS');

export const getUserPreferences = createAction<{
  userId: number;
}>('Manage_PROFILE/GET_USER_PREFERENCES');

// export const updateUserPreferences = createAction('Manage_PROFILE/UPDATE_USER_PREFERENCES');

export const getMyProfile = createAction('GET_MY_PROFILE');
